import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, NavLink, withRouter } from "react-router-dom";
import { Dropdown } from "react-bootstrap";

import { headerList } from "../constants/header";
import SubHeader from "./subHeader";
import Logo from "../assets/images/logo.png";
import "./header.scss";

const Header = ({ history, userDetails, isAdmin }) => {
	const oddEvent = (match, location, to) => {
		return location.pathname.startsWith(to);
	};

	const [show, setShow] = useState(false);

	const renderNav = () => (
		<ul className="main-nav">
			{headerList.map(({ id, to, label, icon, isNewTab }, index) => {
				return (
					<li key={index}>
						{isNewTab ? (
							<a href={to} target="_blank" rel="noopener noreferrer">
								{icon && (
									<span className="nav-icon">
										<i className={`icon icon-${icon}`} />
									</span>
								)}
								<span className="nav-title">{label}</span>
							</a>
						) : (
							<NavLink
								to={to}
								isActive={(match, location) => oddEvent(match, location, to)}
								activeClassName="active">
								{icon && (
									<span className="nav-icon">
										<i className={`icon icon-${icon}`} />
									</span>
								)}
								<span className="nav-title">{label}</span>
							</NavLink>
						)}
					</li>
				);
			})}
		</ul>
	);

	const signOutSubmit = () => {
		localStorage.removeItem("MEDIWEIGHTLOSS_USER_DATA");
		history.push("/signin");
	};

	const [profileDropDown, setProfileDropDown] = useState(null);

	document.addEventListener("click", (e) => {
		profileDropDown && (!profileDropDown.contains(e.target) || !profileDropDown === e.target) && setShow(false);
	});

	return (
		<React.Fragment>
			<header>
				<div className="container print-hidden">
					<div className="logo-container">
						<Link to={"home"}>
							<img src={Logo} alt="MEDI WEIGHT LOSS" />
						</Link>
						<span className="beta-text">(beta)</span>
					</div>
					<div className="nav-container">{renderNav()}</div>
					<div className="profile-container" ref={(e) => setProfileDropDown(e)}>
						<Dropdown alignRight show={show}>
							<Dropdown.Toggle as="div" className="profile-title text-right" onClick={() => setShow(!show)}>
								{userDetails && userDetails.user
									? `${userDetails.user.first_name} ${userDetails.user.middle_name} ${userDetails.user.last_name}`
									: "Profile Name"}
							</Dropdown.Toggle>
							<Dropdown.Menu>
								<div className="profile-dropdown-wrap">
									<div className="profile-dropdown-menu-list">
										<Link className="dropdown-item" to="/my-favourites" onClick={() => setShow(false)}>
											<i className="icon icon-favourite mr-2" /> My favorites
										</Link>
										<Link className="dropdown-item" to="/my-badges" onClick={() => setShow(false)}>
											<i className="icon icon-badge mr-2" /> My badges
										</Link>
										{isAdmin ? (
											<React.Fragment>
												<Link className="dropdown-item" to="/ads" onClick={() => setShow(false)}>
													<i className="icon icon-ad-management mr-2" /> Ad management
												</Link>
												<Link
													className="dropdown-item"
													to="/motivational-content"
													onClick={() => setShow(false)}>
													<i className="icon icon-motivational mr-2" /> Motivational content
												</Link>
											</React.Fragment>
										) : null}
										<Link className="dropdown-item" to="/testimonials" onClick={() => setShow(false)}>
											<i className="icon icon-comment mr-2" /> Testimonials
										</Link>
										<div className="dropdown-item" onClick={signOutSubmit}>
											<i className="icon icon-sign-out mr-2" /> Sign out
										</div>
									</div>
									{userDetails && userDetails.user && userDetails.user.clinic ? (
										<div className="clinic-details cursor-default">
											<h5 className="text-primary-dark">My Clinic</h5>
											<div>
												{userDetails.user.clinic.name}
												<br />
												{userDetails.user.clinic.city}, {userDetails.user.clinic.state}
											</div>
											<div className="text-primary-dark">{userDetails.user.clinic.phone}</div>
										</div>
									) : null}
								</div>
							</Dropdown.Menu>
						</Dropdown>
					</div>
				</div>
			</header>
			<SubHeader />
		</React.Fragment>
	);
};

const mapStateToProps = (state) => ({
	userDetails: state.Auth.userDetails,
	isAdmin: state.Auth.isAdmin
});

export default withRouter(connect(mapStateToProps)(Header));
